<template>
  <div class="main_container">
    <template v-if="isDisplay">
      <div class="col-md-3 left_col menu_fixed hidden-print">
        <side-bar />
      </div>
      <div class="top_nav hidden-print">
        <div class="nav_menu">
          <div v-if="!isUs" class="multi-language">
            <p class="language">{{ $t('common.language') }}：</p>
            <select v-model="language">
              <option value="ja">日本語</option>
              <option value="us">English</option>
              <option v-if="!isCn" value="zh-tw">中文(繁體字)</option>
              <option v-if="!isTw" value="zh-cn">中文(简体字)</option>
            </select>
          </div>
          <div class="logout">
            <a @click="logout" href="#">
              <i class="fa fa-sign-out"></i> Log Out
            </a>
          </div>
        </div>
      </div>
      <router-view />
      <div class="hidden-print">
        <footer-item />
      </div>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>
<style lang="sass" scoped>
@import "./assets/font-awesome/css/font-awesome.min.css"
@import "./assets/bootstrap/css/bootstrap.min.css"
@import "./assets/css/custom.min.css"
</style>
<style scoped>
.logout {
  margin-left: auto;
  padding: 5px;
  text-align: right;
}
.nav_menu {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.multi-language {
  display: flex;
  align-items: center;
}
.language {
  margin: 0 0 0 10px;
  font-weight: bold;
}
</style>
<script>
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'

import SideBar from '@/components/common/sidebar/SideBar'
import Footer from '@/components/common/footer/Footer'

export default {
  components: {
    SideBar,
    FooterItem: Footer,
  },
  data() {
    return {
      isDisplay: true,
      currentPath: '',
    }
  },
  computed: {
    ...mapGetters({
      getLanguage: 'settings/getLanguage',
    }),
    language: {
      get() {
        return this.getLanguage
      },
      set(lang) {
        this.updateLanguage(lang)
      },
    },
    defaultLanguage() {
      return process.env.VUE_APP_LANG
    },
    isUs() {
      return this.defaultLanguage === 'us'
    },
    isTw() {
      return this.defaultLanguage === 'zh-tw'
    },
    isCn() {
      return this.defaultLanguage === 'zh-cn'
    },
  },
  watch: {
    $route() {
      if (this.$route.meta.ExclusionTemplate) {
        this.isDisplay = false
      } else {
        this.isDisplay = true
      }
    },
    language() {
      this.$i18n.locale = this.language
      this.$validator.localize(this.language)
      axios.defaults.headers.common['Language-Id'] = this.language
    },
  },
  mounted() {
    if (this.$route.meta.ExclusionTemplate) {
      this.isDisplay = false
    } else {
      this.isDisplay = true
    }
  },
  methods: {
    ...mapActions({
      updateLanguage: 'settings/updateLanguage',
    }),
    logout: function() {
      this.$store.commit('resetVuexState')
      this.$router.push({ name: 'login' })
    },
  },
}
</script>
